import { createContext, useContext } from "react";

export interface NearbyAirportsContextValue {
  showNearbyAirports: boolean;
  setShowNearbyAirports: (value: boolean) => void;
  destinationAirportCode: string;
  hasNearbyAirports: boolean;
  setHasNearbyAirports: (value: boolean) => void;
  isNearbyAirport: (destinationCode: string) => boolean;
}

export const NearbyAirportsContext = createContext<
  NearbyAirportsContextValue | undefined
>(undefined);

export const useNearbyAirports = () => {
  const ctx = useContext(NearbyAirportsContext);
  if (!ctx) {
    throw new Error(
      "useNearbyAirports must be used within a NearbyAirportsContext provider"
    );
  }
  return ctx;
};

export const createReadOnlyNearbyAirportsContext = (
  destinationAirportCode: string
): NearbyAirportsContextValue => {
  // eslint-disable-next-line @typescript-eslint/no-empty-function
  const noop = () => {};
  return {
    showNearbyAirports: true,
    setShowNearbyAirports: noop,
    destinationAirportCode,
    hasNearbyAirports: false,
    setHasNearbyAirports: noop,
    isNearbyAirport: (code) => code !== destinationAirportCode,
  };
};
